module.exports = __webpack_public_path__ + "static/media/plate4_icon5.388ae4c1.png";